import { Stack, Textarea } from "@mantine/core";
import { useTranslation } from "react-i18next";

export default function AmslerGridTestEntry({ entry }) {
  const { t } = useTranslation();
  const testResult = entry;
  return (
    <Stack gap={0} mb={"md"}>
      <Textarea label={t("comments")} value={testResult?.comment} />
    </Stack>
  );
}
